import { render } from "./Profile.vue?vue&type=template&id=502426f2"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=502426f2&lang=css"

import exportComponent from "/Users/borchekostovski/Documents/Projects/CreativeLabs/Projects/Ching-a-ling/ching-a-ling-cms-menu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__